import styled from 'styled-components';

const ControlContainer = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  width: ${(props) => props.width ? props.width : '100%'};
`;

export default ControlContainer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/ControlContainer/index.js